import Swiper from "swiper";
import { find } from "utils/dom";

export default function () {
	const Consultancies = find("[js-page='consultancies']");
	if (!Consultancies) return;

	document.addEventListener('DOMContentLoaded', function () {
		const swiperTestimonials = new Swiper('.swiper-testimonials', {
			slidesPerView: 1,
			centeredSlides: false,
			speed:1000,
			spaceBetween: 24,
			navigation: {
				nextEl: '.testimonials-container .testimonials-button-next',
				prevEl: '.testimonials-container .testimonials-button-prev',
			},
			pagination: { 
        el: '.swiper-pagination-testimonials',
        type: 'fraction',
			},
			breakpoints: {
				768: { 
					slidesPerView: 'auto'
				}
			}	
		});
	});
}
